import HomeOutlineTwo from '@assets/icons/home-outline-two.svg'
import { Icon } from './Icon'

export const HomeOutlineTwoIcon = Icon(HomeOutlineTwo)
